import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateCaseManage } from '../../../../../../services/CaseManagementService';

const coverageOptions = [
  'Not Supported',
  'Clinical Records',
  'History and Physical',
  'Imaging Report',
  'Pathology',
  'Physical Therapy Notes',
  'Psychological Evaluation',
  'Other'
];

const Dx2CoverageStatusField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const diagnosis2Value = currentCase?.codingDetails?.diagnosisCodes?.diagnosis2 || '';
  const isDiagnosisEmpty = !diagnosis2Value.trim();
  const coverageValue = isDiagnosisEmpty ? 'Not Supported' : (currentCase?.codingDetails?.diagnosisCodes?.dx2CoverageStatus || '');

  const handleCoverageChange = (value: string) => {
    if (!currentCase?.codingDetails?.diagnosisCodes) return;
    
    const updatedDiagnosisCodes = {
      ...currentCase.codingDetails.diagnosisCodes,
      dx2CoverageStatus: value
    };
    
    dispatch(updateCaseManage({
      codingDetails: {
        ...currentCase.codingDetails,
        diagnosisCodes: updatedDiagnosisCodes
      }
    }));
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth>
        <InputLabel>Dx2 Coverage Status</InputLabel>
        <Select
          value={coverageValue}
          onChange={(e) => handleCoverageChange(e.target.value)}
          label="Dx2 Coverage Status"
          disabled={isDiagnosisEmpty}
        >
          <MenuItem value="">Select Status</MenuItem>
          {coverageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Dx2CoverageStatusField;
